import { render, staticRenderFns } from "./SailDetailPage.vue?vue&type=template&id=5d7d2628&scoped=true&"
import script from "./SailDetailPage.vue?vue&type=script&lang=js&"
export * from "./SailDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7d2628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7d2628')) {
      api.createRecord('5d7d2628', component.options)
    } else {
      api.reload('5d7d2628', component.options)
    }
    module.hot.accept("./SailDetailPage.vue?vue&type=template&id=5d7d2628&scoped=true&", function () {
      api.rerender('5d7d2628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/SailDetailPage.vue"
export default component.exports